// Who is signed in on this phone right now, for the outbox (security review C1). The sign-in gate sets it; the
// outbox reads it so each row keeps its maker and only goes while that person is signed in. Kept tiny and apart
// from app-data so the sign-in screen can clear it without loading the data code.
let current: string | null = null;
const listeners = new Set<() => void>();

export const signedInUser = {
  get: (): string | null => current,
  set: (id: string | null): void => {
    if (id === current) return;
    current = id;
    for (const l of listeners) l();
  },
  subscribe: (l: () => void): (() => void) => {
    listeners.add(l);
    return () => {
      listeners.delete(l);
    };
  },
};
